import styled from "styled-components";

export const Container = styled.div`
  width: 100%;

  .notches {
    padding: 0 8px 0 12px;
    display: flex;
    justify-content: space-between;
    pointer-events: none;
  }

  .notch {
    height: 13px;
    width: 5px;
    background-color: #ccc;
    border-radius: 2px;
    margin-top: -17px;
    pointer-events: none;
  }

  .transparent {
    background-color: transparent;
  }
`;

export const Input = styled.input`
  -webkit-appearance: none;
  width: 100%;
  background: transparent;
  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    background-color: #41a8bf;
    color: #41a8bf;
    height: 30px;
    width: 25px;
    border-radius: 10px;
    margin-top: -7px;
  }
  &::-moz-range-thumb {
    background-color: #41a8bf;
    color: #41a8bf;
    height: 30px;
    width: 24px;
    border: none;
    border-radius: 10px;
    cursor: pointer;
  }
  &::-ms-thumb {
    background-color: #41a8bf;
    color: #41a8bf;
    height: 30px;
    width: 25px;
    border-radius: 10px;
    z-index: 1005;
  }

  &::-webkit-slider-runnable-track {
    height: 14px;
    width: 100%;
    background-color: #dcdde1;
    border-radius: 6px;
    cursor: pointer;
  }
  &::-moz-range-track {
    height: 14px;
    width: 100%;
    background-color: #dcdde1;
    border-radius: 6px;
    cursor: pointer;
  }
  &::-ms-track {
    height: 14px;
    width: 100%;
    background-color: #dcdde1;
    border-radius: 6px;
    cursor: pointer;
  }

  &:focus {
    outline: none;
  }
`;
